<template>
  <vuex-table
    :fields="fields"
    :show_per_page="false"
    :auto_start="false"
    :foot_clone="true"
    :no_footer_sorting="true"
    table_store="mailer/archived_stats/general"
  />
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('mailer/archived_stats/general', ['filter']),

      fields: function () {
        return [
          {
            key: 'caption',
            label: this.$t(`mailer.archived_stats.general.filter.group_by.values.${this.filter.group_by}`),
            sortable: true,
            class: 'column-sticky',
            thStyle: {
              minWidth: '200px'
            }
          },

          {
            key: 'total',
            label: this.$t('mailer.stats.general.field.total'),
            sortable: true,
            thStyle: {
              minWidth: '100px'
            }
          },

          ...['sent', 'delivered', 'not_delivered', 'rejected', 'failed', 'expired'].map((i) => ({
            key: i,
            label: this.$t(`mailer.message.status.${i}`),
            sortable: true,
            thStyle: {
              minWidth: '170px'
            }
          })),

          {
            key: 'cost',
            label: this.$t('mailer.stats.general.field.cost'),
            sortable: true,
            thStyle: {
              minWidth: '150px'
            },

            formatter: (val) => this.$numeral.currency(val)
          }
        ];
      }
    }
  };
</script>
